import React, { useState, useRef } from 'react';
import { Query, useMutation } from 'react-apollo';
import { useSelector } from 'react-redux';
import { API } from 'aws-amplify';
import Helmet from 'react-helmet';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import DataGrid from 'material-table';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';
import Loading from 'components/common/Spin';
import Button from 'components/common/Button';
import useSnack from 'hooks/useSnack';
import placeholderImg from 'assets/files-placeholder.svg';
import {
  GET_SPECIFIC_FILE,
  INSERT_FILE,
  UPDATE_FILE,
  DELETE_FILE,

} from 'graphql/files';
import { GET_USERS } from 'graphql/admin/users';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
}));

const URL = process.env.REACT_APP_URL;

const FileManager = ({student }) => {
  const classes = useStyles();
  const snack = useSnack();
  const user = useSelector((state) => state.user.user);
  console.log("this is user id",student.id)
  const [showAdd, setShowAdd] = useState(false);
  const [addFile] = useMutation(INSERT_FILE);
  const [updateFile] = useMutation(UPDATE_FILE);
  const [deleteFile] = useMutation(DELETE_FILE);
  const [remaningDays, setRemaningDays] = useState(0);
  const refetchRef = useRef();

  const onAddFile = async (values) => {

    try {
      const { data } = await addFile({
        variables: {
          input: {
            ...values,
            user_id: user.id,
          },
        },
      });
      toggleAdd();
      await refetchRef.current();
    } catch (e) {
      snack.error(e.message);
    }
  };

  const toggleAdd = () => {
    setShowAdd(!showAdd);
  };

  const handleDelete = async (data) => {
    await deleteFile({
      variables: {
        id: data.id,
      },
    });
    await refetchRef.current();
  };

  const onDownload = async (e, file) => {
    const resp = await API.get('api', `/files/${file.id}`);
    window.open(resp.url);
  };

  const onToggleShare = async (e, file) => {
    const resp = await updateFile({
      variables: {
        id: file.id,
        file: {
          shared: !file.shared,
        },
      },
    });
  };

  const columns = [
    { title: 'File Name', field: 'filename' },
    { title: 'File', field: 'original_name' },
    { title: 'Date Uploaded', field: 'created_at', type: 'date' },
    {
      title: 'Share',
      field: 'shared',
      type: 'boolean',
      render: (row) => {
        if (row.shared) {
          return (
            <CopyToClipboard
              text={`${URL}/f/${row.id}`}
              onCopy={() => snack.success('Link copied to clipboard')}
            >
              <IconButton size="small">
                <CopyIcon fontSize="inherit" />
              </IconButton>
            </CopyToClipboard>
          );
        }
        return '-';
      },
    },
  ];

  return (
    <Box>
      <Helmet title="My Files" />
      <Query query={GET_SPECIFIC_FILE}
      variables={{userId:student.id}}
      fetchPolicy={'cache-and-network'}>
        {({ data, loading, error, refetch }) => {
          console.log("new Data",data)
          refetchRef.current = refetch;

          if (error) return <div>{error.message}</div>;
          if (loading) return <Loading />;

          if (!data.files.length) {
            return (
              <Paper>
                <Box textAlign="center" px={3} py={6}>
                  <Box mb={3}>
                    <img src={placeholderImg} alt="placeholderImg" />
                  </Box>
                  <Box>
                    <Typography variant="h5">You have no files yet</Typography>
                    <Typography paragraph variant="caption" component="p">
                      Upload files using button below
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            );
          }
          return (
            <Box>
              <Box textAlign="right" mb={2}>
              </Box>
              <Box>
                <DataGrid
                  options={{
                    showTitle: false,
                    actionsColumnIndex: -1,
                  }}
                  localization={{
                    body: {
                      editRow: {
                        deleteText:
                          'Are you sure you want to delete this file?',
                      },
                    },
                  }}
                  columns={columns}
                  data={data.files}
                  editable={{
                    onRowDelete: handleDelete,
                  }}
                  actions={[
                    {
                      icon: 'download',
                      tooltip: 'Download',
                      onClick: onDownload,
                    },
                    {
                      icon: 'share',
                      tooltip: 'Toggle share',
                      onClick: onToggleShare,
                    },
                  ]}
                />
              </Box>
            </Box>
          );
        }}
      </Query>
    </Box>
  );
};

export default FileManager;

